import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useHistory, useLocation } from "react-router-dom";
import "./Navigation.css";
import logo from "../../assets/images/icons/logo-ikiai.png";
import { useTranslation } from "react-i18next";

const expand = "lg";

const languageMap = {
  en: "English",
  zh: "中文",
  ja: "日本語",
};

function Navigation() {
  const { i18n } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const getActiveItem = (path) => {
    if (path.startsWith("/download")) return "download";
    if (path.startsWith("/blog")) return "blog";
    if (path.startsWith("/contact")) return "contact";
    return "home";
  };

  const [selectedLanguage, setSelectedLanguage] = useState(
    languageMap[i18n.language] || "English"
  );
  const [activeNavItem, setActiveNavItem] = useState(getActiveItem(location.pathname));
  const [showMenu, setShowMenu] = useState(false);

  // Sync active item with path changes
  React.useEffect(() => {
    setActiveNavItem(getActiveItem(location.pathname));
  }, [location.pathname]);

  const handleSelectLanguage = (language) => {
    i18n.changeLanguage(language);
    setSelectedLanguage(languageMap[language]);
    setShowMenu(false);
  };

  const handleNavItemClick = (item) => {
    setActiveNavItem(item);
    setShowMenu(false);

    if (item === "home") {
      history.push("/");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (item === "contact") {
      history.push("/contact");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (item === "blog") {
      history.push("/blog");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (item === "download") {
      history.push("/download");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const isWhiteBg = location.pathname.startsWith("/blog") ||
    location.pathname.toLowerCase().startsWith("/contact")

  return (
    <div className={`nav-wrapper fixed-top navbar navbar-toggleable-sm navbar-expand-md navbar-custom ${isWhiteBg ? "nav-white-bg" : ""}`}>
      <div className="navBar">
        <Navbar key={expand} expand={expand} className={`w-100 ${isWhiteBg ? "bg-white" : "bg-light-custom"}`}>
          <Navbar.Brand href="/">
            <img className="logo-ikiai" src={logo} alt="" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls={`offcanvasNavbar-expand-${expand}`}
            onClick={() => setShowMenu(!showMenu)}
          />
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-${expand}`}
            aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
            placement="start"
            show={showMenu}
            onHide={() => setShowMenu(false)}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title
                id={`offcanvasNavbarLabel-expand-${expand}`}
              ></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-end flex-grow-1 pe-3">
                <Nav.Item>
                  <Nav.Link
                    className={`nav-link global-text ${activeNavItem === "home" ? "active" : ""}`}
                    onClick={() => handleNavItemClick("home")}
                  >
                    {i18n.t("nav.home")}
                    {activeNavItem === "home" && (
                      <span className="nav-focus-dot"></span>
                    )}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    className={`nav-link global-text ${activeNavItem === "blog" ? "active" : ""}`}
                    onClick={() => handleNavItemClick("blog")}
                  >
                    {i18n.t("nav.blog")}
                    {activeNavItem === "blog" && (
                      <span className="nav-focus-dot"></span>
                    )}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="nav-download-item">
                  <Nav.Link
                    className={`nav-link global-text ${activeNavItem === "download" ? "active" : ""}`}
                    onClick={() => handleNavItemClick("download")}
                  >
                    {i18n.t("nav.download")}
                    {activeNavItem === "download" && (
                      <span className="nav-focus-dot"></span>
                    )}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Link
                  className={`nav-link global-text ${activeNavItem === "contact" ? "active" : ""}`}
                  onClick={() => handleNavItemClick("contact")}
                >
                  {i18n.t("nav.contact")}
                  {activeNavItem === "contact" && (
                    <span className="nav-focus-dot"></span>
                  )}
                </Nav.Link>


                <NavDropdown
                  title={<span className="global-text">{selectedLanguage}</span>}
                  id="offcanvasNavbarDropdown-expand-lg"
                  className="nav-lang-dropdown"
                >
                  <NavDropdown.Item onClick={() => handleSelectLanguage("en")} className="global-text">
                    English
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => handleSelectLanguage("zh")} className="global-text">
                    中文
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => handleSelectLanguage("ja")} className="global-text">
                    日本語
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Navbar>
      </div>
    </div>
  );
}

export default Navigation;
